import { TextCapitalized } from "@qivia/ui";
import { Spacer } from "@qivia/ui/src/designSystem/components/Spacer";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import * as XLSX from "xlsx";
import { driverPlanningHeaderColumns } from "../driverPlanningFormat/driverPlanningsHeaders";
import { DriverPlanningDisplayFile } from "./driverPlanningDisplayFile";

const DRIVER_PLANNING_TEMPLATE_FILE_NAME = "fichier_d_import_de_plannings.xlsx";

export const DriverPlanningTemplateDownload = () => {
  const { t } = useTranslation();

  const downloadDriverPlanningTemplate = useCallback(() => {
    const headers = driverPlanningHeaderColumns.map(
      (column) => column.acceptedHeaders[0],
    );
    const workBook = XLSX.utils.book_new();
    const workSheet = XLSX.utils.aoa_to_sheet([headers]);

    XLSX.utils.book_append_sheet(workBook, workSheet, "Plannings");
    XLSX.writeFile(workBook, DRIVER_PLANNING_TEMPLATE_FILE_NAME);
  }, []);

  return (
    <>
      <DriverPlanningImportStepTitle
        step={1}
        title={t("trips.importPlanning.downloadModel")}
      />
      <Spacer y={2} />
      <DriverPlanningDisplayFile
        selectedFile={DRIVER_PLANNING_TEMPLATE_FILE_NAME}
        handleDownload={downloadDriverPlanningTemplate}
        type="DOWNLOAD"
      />
    </>
  );
};

export const DriverPlanningImportStepTitle = (props: {
  step: number;
  title: string;
}) => (
  <StyledStepTitle>
    <StyledStepNumber>{props.step}</StyledStepNumber>
    <Spacer x={0.75} />
    <TextCapitalized>{props.title}</TextCapitalized>
  </StyledStepTitle>
);

const StyledStepTitle = styled.div`
  display: flex;
  align-items: center;
`;

const StyledStepNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.5rem;
  background-color: ${colors["colors/surfaces/background/background_level1"]};
`;
